// extracted by mini-css-extract-plugin
export default {"date-form":"DateForm_date-form__KgHAQ","date-form__input-wrapper":"DateForm_date-form__input-wrapper__taikd"};